import { useGetPlanDiffQuery, GetPlanDiffInput } from '@graphql/generated/graphql';

const useGetPlanDiff = (input: GetPlanDiffInput, enabled: boolean = true) => {
  const { data, isLoading, isError, isSuccess, error, refetch } = useGetPlanDiffQuery(
    { input },
    {
      enabled,
      staleTime: 0,
      cacheTime: 0,
      refetchInterval: false,
      refetchOnWindowFocus: false,
      retry: false,
    },
  );

  return {
    result: data?.getPlanDiff || { newEntries: [], endedEntries: [], extendedEntries: [], deletedEntries: [] },
    isLoading,
    isError,
    isSuccess,
    error,
    refetch,
  };
};

export default useGetPlanDiff;
